import { lazy, Suspense, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { WhatsAppDrawerContext } from './whatsapp-drawer-context';

const WhatsAppMessageDrawer = lazy(() => import('@/components/common/Drawer/WhatsAppMessageDrawer'));

export default function WhatsAppDrawerProvider({ children }) {
  // Keep the conversation mounted even when a plan removes its source row
  // from a filtered CRM list. Only the operator closes the drawer.
  const [contact, setContact] = useState(null);
  const openWhatsAppDrawer = useCallback((details) => setContact(details), []);
  const closeWhatsAppDrawer = useCallback(() => setContact(null), []);
  const value = useMemo(() => ({ openWhatsAppDrawer }), [openWhatsAppDrawer]);

  return (
    <WhatsAppDrawerContext.Provider value={value}>
      {children}
      {contact && (
        <Suspense fallback={null}>
          <WhatsAppMessageDrawer
            {...contact}
            mode="contact"
            isOpen
            onClose={closeWhatsAppDrawer}
          />
        </Suspense>
      )}
    </WhatsAppDrawerContext.Provider>
  );
}

WhatsAppDrawerProvider.propTypes = { children: PropTypes.node };
